"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var AcToast_1 = require("../../notification/AcToast");
var AcPdfSetPhraseInputs_1 = require("./AcPdfSetPhraseInputs");
var AcPdfSetPhraseSaveButtons_1 = require("./AcPdfSetPhraseSaveButtons");
var AcPageTitle_1 = require("../../layout/AcPageTitle");
var getGraphQLErrorForPath = function (error, path) {
    var _a;
    if (((_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        var err = error.graphQLErrors.find(function (e) {
            var _a;
            if (path !== undefined && ((_a = e === null || e === void 0 ? void 0 : e.path) === null || _a === void 0 ? void 0 : _a[0]) === path) {
                return true;
            }
            return false;
        });
        if (err) {
            return err;
        }
    }
    return undefined;
};
var getUserInputErrorForPath = function (error, path) {
    var graphQLError = getGraphQLErrorForPath(error, path);
    if (graphQLError) {
        var extensions = graphQLError.extensions;
        if ((extensions === null || extensions === void 0 ? void 0 : extensions.code) === 'BAD_USER_INPUT') {
            extensions.faxNumber = extensions.fax;
            return extensions;
        }
    }
    return undefined;
};
exports.createFaxSetPhraseMutation = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateFaxContactMutation($input: CreateFaxSetPhraseInput!) {\n    createFaxSetPhrase(input: $input) {\n      faxSetPhrase {\n        setPhrase\n      }\n    }\n  }\n"], ["\n  mutation CreateFaxContactMutation($input: CreateFaxSetPhraseInput!) {\n    createFaxSetPhrase(input: $input) {\n      faxSetPhrase {\n        setPhrase\n      }\n    }\n  }\n"])));
exports.updateFaxSetPhraseMutation = client_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation UpdateFaxContactMutation($input: UpdateFaxSetPhraseInput!) {\n    updateFaxSetPhrase(input: $input) {\n      faxSetPhrase {\n        id\n        faxSetPhraseId\n        setPhrase\n      }\n    }\n  }\n"], ["\n  mutation UpdateFaxContactMutation($input: UpdateFaxSetPhraseInput!) {\n    updateFaxSetPhrase(input: $input) {\n      faxSetPhrase {\n        id\n        faxSetPhraseId\n        setPhrase\n      }\n    }\n  }\n"])));
exports.AcPdfSetPhraseEditor = function (_a) {
    var faxSetPhrase = _a.faxSetPhrase, backwards = _a.backwards;
    var _b = react_1.useState((faxSetPhrase === null || faxSetPhrase === void 0 ? void 0 : faxSetPhrase.setPhrase) || ''), setPhrase = _b[0], setSetPhrase = _b[1];
    var _c = react_1.useState({
        empty: false,
        length: false,
        duplicated: false,
    }), setPhraseError = _c[0], setSetPhraseError = _c[1];
    var _d = client_1.useMutation(exports.createFaxSetPhraseMutation), createFaxSetPhrase = _d[0], loadingCreate = _d[1].loading;
    var _e = client_1.useMutation(exports.updateFaxSetPhraseMutation), updateFaxSetPhrase = _e[0], loadingUpdate = _e[1].loading;
    react_1.useEffect(function () {
        if (!setPhrase || setPhrase.length === 0) {
            setSetPhraseError({
                empty: true,
                length: false,
                duplicated: false,
            });
        }
    }, [setPhrase]);
    var setPhraseDuplicateError = function (e, name) {
        var _a;
        var userInputError = getUserInputErrorForPath(e, name);
        if (userInputError && ((_a = userInputError.setPhrase) === null || _a === void 0 ? void 0 : _a.message)) {
            setSetPhraseError({ empty: false, length: false, duplicated: true });
        }
        else {
            AcToast_1.notifyMessage('定型文の登録に失敗しました。', 'ERROR');
        }
    };
    var createSetPhrase = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newFaxSetPhrase, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newFaxSetPhrase = {
                        setPhrase: setPhrase,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createFaxSetPhrase({ variables: { input: newFaxSetPhrase } })];
                case 2:
                    _a.sent();
                    backwards();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setPhraseDuplicateError(e_1, 'createFaxSetPhrase');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateSetPhrase = function (faxSetPhraseId) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFaxSetPhrase, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedFaxSetPhrase = {
                        faxSetPhraseId: faxSetPhraseId,
                        setPhrase: setPhrase,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateFaxSetPhrase({
                            variables: { input: __assign(__assign({}, updatedFaxSetPhrase), { id: updatedFaxSetPhrase.faxSetPhraseId }) },
                        })];
                case 2:
                    _a.sent();
                    backwards();
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    setPhraseDuplicateError(e_2, 'updateFaxSetPhrase');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var saveSetPhrase = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loadingCreate || loadingUpdate) {
                        return [2 /*return*/];
                    }
                    if (!!faxSetPhrase) return [3 /*break*/, 2];
                    return [4 /*yield*/, createSetPhrase()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, updateSetPhrase(faxSetPhrase.faxSetPhraseId)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var cancelSetPhrase = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (loadingCreate || loadingUpdate) {
                return [2 /*return*/];
            }
            backwards();
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AcPageTitle_1.AcPageTitle, null,
            react_1.default.createElement("span", { className: "text-primary" },
                react_1.default.createElement("i", { className: "far fa-pencil-alt fa-fw fs-22 mr-1" }),
                react_1.default.createElement("span", { className: "fs-18 font-weight-bold" }, "\u5B9A\u578B\u6587\u306E\u767B\u9332\u30FB\u7DE8\u96C6"))),
        react_1.default.createElement("div", { className: "d-flex flex-column text-left mb-4" },
            react_1.default.createElement(AcPdfSetPhraseInputs_1.AcPdfSetPhraseInputs, { setPhrase: setPhrase, setSetPhrase: setSetPhrase, setPhraseError: setPhraseError, setSetPhraseError: setSetPhraseError })),
        react_1.default.createElement("div", { className: "d-flex flex-column mb-4" },
            react_1.default.createElement(AcPdfSetPhraseSaveButtons_1.AcPdfSetPhraseSaveButtons, { onClickSave: saveSetPhrase, onClickCancel: cancelSetPhrase, loading: loadingCreate || loadingUpdate, error: setPhraseError.empty || setPhraseError.length || setPhraseError.duplicated }))));
};
exports.AcPdfSetPhraseEditor.displayName = 'AcPdfSetPhraseEditor';
var templateObject_1, templateObject_2;
//# sourceMappingURL=AcPdfSetPhraseEditor.js.map